import { routePaths } from 'components/Routes/data';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PendingApproval } from './PendingApproval';
import { InitiatedByMe } from './InitiatedByMe';
import { Completed } from './Completed';

const SalaryRevision = () => {
  return (
    <Switch>
      <Route path={routePaths.approvalWorkflows.myRequests.salaryRevision.pendingApprovals} exact>
        <PendingApproval />
      </Route>
      <Route path={routePaths.approvalWorkflows.myRequests.salaryRevision.initiatedByMe} exact>
        <InitiatedByMe />
      </Route>
      <Route path={routePaths.approvalWorkflows.myRequests.salaryRevision.completed} exact>
        <Completed />
      </Route>
    </Switch>
  );
};

export { SalaryRevision };
